import { getId } from 'services/utils'
import { findSingleFacet, bundleFacetIds } from 'ui-shared/Facets'
import { parseQuantityHint, writeQuantityHint } from 'ui-shared/Hints/common'
import { parseFacet, PricingFacet } from '../facets'
import { productCommonParse, productCommonWrite } from '../productCommon'
import { UpsellingToAPI } from './types/api/request-models'
import { APIUpselling } from './types/api/response-models'
import { Upselling } from './types/internal/upselling-models'

// ============
// PARSE
// ============

export const upsellingParse = (res: APIUpselling): Upselling => {
  const facets = res.facets.map(parseFacet)
  const pricingFacet = findSingleFacet(facets, 'pricing')
  const groupFacet = findSingleFacet(facets, 'group')

  return {
    ...res,
    ...productCommonParse(res),
    ...parseQuantityHint(res),
    pricingFacet,
    groupFacet,
    isPerItem: facets.some(
      (f) => (f as PricingFacet).pricingType === 'perItem'
    ),
    products: res.products?.map(getId) ?? [],
  }
}

// ============
// WRITE
// ============

export const upsellingWrite = async ({
  pricingFacet,
  groupFacet,
  isPerItem,
  ...req
}: Upselling): Promise<UpsellingToAPI> => {
  const facets = bundleFacetIds(groupFacet, pricingFacet)

  return {
    ...req,
    ...(await productCommonWrite(req)),
    facets,
    products: req.products ?? [],
    quantityHint: isPerItem ? writeQuantityHint(req) : [],
  }
}
